// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"mobileBoard_mulitpleDropdown__3BI6S","wrapper":"mobileBoard_wrapper__rY7Zb","tabs":"mobileBoard_tabs__2Wh4E"};